




































import { classlist } from "@/api/teacherManage";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
@Component
export default class extends Vue {
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 20;
  pageSizeArray: number[] = [20, 50, 100];
  total: number = 0;
  mounted() {
    this.getlistData({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getlistData(data: { page: number; page_size: number }) {
    classlist({
      page: data.page,
      page_size: data.page_size,
      staff_id: Number(this.$route.query.id),
    }).then((res: any) => {
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getlistData({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getlistData({
      page: 1,
      page_size: e,
    });
  }
  toClassDetails(e: any) {
    this.$router.push({
      name: "classManageDetail",
      query: {
        id: e.class_id,
      },
    });
  }
}
